module.exports = __webpack_public_path__ + "img/zeroThree.55a37ef3.png";